import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, inject, OnChanges, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import {
  EnumService,
  ProfissionaisRepresentacaoEmpresaService,
  ProfissionaisTipoRepresentacaoService,
} from '@app/features-modules/gestao-bolseiros/components/api/services';
import { ApiService } from '@core/providers/http';
import { Avatar } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-representante-card',
  imports: [CommonModule, Avatar],
  providers: [
    ApiService,
    EnumService,
    ProfissionaisRepresentacaoEmpresaService,
    ProfissionaisTipoRepresentacaoService,
  ],
  templateUrl: './representante-card.component.html',
  styleUrls: ['./representante-card.component.scss'],
  standalone: true,
})
export class RepresentanteCardComponent implements OnChanges {
  @Input() instituicaoEnsino: any;
  @Input() representante: any;
  @Input() foto: string | ArrayBuffer | null = null;
  @Output() edit = new EventEmitter<any>();
  @Output() desativar = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() notificar = new EventEmitter<any>();
  @Output() redefinirSenha = new EventEmitter<any>();

  Show = false;
  photoUrl: string | null = null;
  imageError = false;
  getInitials = getInitials;
  profissionaisRepresentacaoEmpresaService = inject(
    ProfissionaisRepresentacaoEmpresaService
  );

  constructor(private router: Router) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.imageError = false;
    if (changes['representante'] && this.representante?.id) {
      this.loadPhoto();
    }
  }

  loadPhoto() {
    this.profissionaisRepresentacaoEmpresaService
      .getPhoto(this.representante.id)
      .subscribe(
        (response: Blob) => {
          if (response) {
            if (!response.type?.startsWith('image/')) {
              this.photoUrl = null;
              return;
            }
            const reader = new FileReader();
            reader.onload = () => {
              this.photoUrl = reader.result as string;
            };
            reader.readAsDataURL(response);
          } else {
            this.photoUrl = null;
          }
        },
        (error) => {
          this.photoUrl = null;
        }
      );
  }

  ShowDetais(event: Event) {
    event.stopPropagation();
    this.Show = !this.Show;
  }

  Editar(event: Event) {
    event.stopPropagation();
    this.edit.emit(this.representante);
  }

  Desativar(event: Event) {
    event.stopPropagation();
    this.desativar.emit(this.representante);
  }

  Deletar(event: Event) {
    event.stopPropagation();
    this.delete.emit(this.representante);
  }

  Notificar(event: Event) {
    event.stopPropagation();
    this.notificar.emit(this.representante);
  }

  RedefinirSenha(event: Event) {
    event.stopPropagation();
    this.redefinirSenha.emit(this.representante);
  }
}
